





import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class SchoolNotFoundError extends Vue {
  @Prop({
    required: false,
    default: () => ({}),
    type: Object
  })
  public params!: Record<string, any>;

  public get message() {
    return `Unbekannte Schulzuordnung: 
      Leider wurde Ihre Schule (Dienststellenschlüssel: ${this.params.dish || '<DISH>'}) 
      noch nicht korrekt im System hinterlegt.
      Bitte kontaktieren Sie die Hotline unter: 0711 4909-6358 
      oder per Email: sesam@lmz-bw.de`;
  }
}
